window.addEventListener('DOMContentLoaded', (event) => {

    // Check if '.statisical-calculator__main-content--pre-test.calculator' exists
    var preTestCalculator = document.querySelector('.statisical-calculator__main-content--pre-test.calculator');

    if (!preTestCalculator) {
        // console.log('Pre-test calculator not found!');
        return; // Exit the function early if the element is not found
    }

    var toggleButtons = document.querySelectorAll('.statisical-calculator__main-content .statisical-calculator__main-content--toggle-buttons .toggle-buttons button');

    if (toggleButtons.length > 0) {
        toggleButtons.forEach(function(button) {
            button.addEventListener('click', toggleCalculator);
        });
    } else {
        // console.log('No toggle buttons found!');
    }

    function toggleCalculator(e) {
        // console.log('Toggle Calculator Called!'); 
        
        const selectedButton = document.querySelector('.statisical-calculator__main-content .statisical-calculator__main-content--toggle-buttons .toggle-buttons .selected');
        
        if (!selectedButton) {
            // console.log('No button with "selected" class found!');
            return;
        }

        selectedButton.classList.remove('selected');
        e.target.classList.add('selected');
        // console.log('Toggled Selected Class!');  
        
        if (e.target.classList.contains('toggle-buttons__pre-test')) {
            // console.log('Pre-test Button Clicked!');
            document.querySelector('.statisical-calculator__main-content--pre-test.calculator').classList.remove('hidden');
            document.querySelector('.statisical-calculator__main-content--post-test.calculator').classList.add('hidden');
        } else {
            // console.log('Post-test Button Clicked!');
            document.querySelector('.statisical-calculator__main-content--pre-test.calculator').classList.add('hidden');
            document.querySelector('.statisical-calculator__main-content--post-test.calculator').classList.remove('hidden');
        }
    }

/* START: Dummy Data */
var dummyDataButton = document.querySelector('.dummy-data');

dummyDataButton.addEventListener('click', function(e) {
	if (document.querySelector('.statisical-calculator__main-content--pre-test.calculator.hidden')) {
		document.getElementById('control-visitors').value = '34500';
		document.getElementById('control-conversions').value = '1250';
		document.getElementById('variant-visitors').value = '33240';
		document.getElementById('variant-conversions').value = '1300';
		document.getElementById('days-length').value = '14';
		document.getElementById('significance-level').value = '95';
	} else {
		document.getElementById('expected-traffic').value = '34500';
		document.getElementById('expected-conversions').value = '7250';
		document.getElementById('number-of-variants').value = '1';
		document.getElementById('pre-significance-level').value = '95';
	}

	var errors = document.querySelectorAll('p.error-message');
	for (var i = 0; i < errors.length; i++) {
		errors[i].classList.add('hidden')
	}
})
/* END: Dummy Data */ 


/* START: Sided radio buttons */
var sidedRadios = document.querySelectorAll('[name="sided"]'),
	oneSidedLabel = document.querySelector('label[for="one-sided"]'),
	twoSidedLabel = document.querySelector('label[for="two-sided"]'),
	sidedContainer = document.querySelector('.one-two-sided');

for (var i = 0; i < sidedRadios.length; i++) {
	sidedRadios[i].addEventListener('change', detectSidedChange);
}

function detectSidedChange(e) {
	if (e.target.value === "one") {
		oneSidedLabel.classList.add('selected');
		twoSidedLabel.classList.remove('selected');
		sidedContainer.classList.remove('show-notification');
	} else {
		twoSidedLabel.classList.add('selected');
		oneSidedLabel.classList.remove('selected');
		sidedContainer.classList.add('show-notification');

		setTimeout(function() {
			sidedContainer.classList.remove('show-notification');
		}, 7 * 1000);
	}

	writePostResult(calculatePostTestResults());
}

document.body.addEventListener('click', function(e) {
	sidedContainer.classList.remove('show-notification');
});
/* END: Sided radio buttons */

/* START: Post form handler */
var postForm = document.querySelector('form.post-test-form__inner--form'),
	inputFields = postForm.querySelectorAll('input[type="text"],input[type="number"]'),
	firstPostSubmit = true;

postForm.querySelector('.post-test-form__inner--form .button-container button').addEventListener('click', function(e) {
	validatePostForm(e);
	// scrollToResults();
});

for (var i = 0; i < inputFields.length; i++) {
	inputFields[i].addEventListener('keyup', inputKeyUpHandler);
	inputFields[i].addEventListener('blur', inputKeyUpHandler);
}

function validatePostForm(e) {
	if (typeof e !== "undefined") {
		e.preventDefault();
	}

	var calculatorContainer = document.querySelector('.calculator:not(.hidden)');

	calculatorContainer.classList.add('loading');

	var foundErrors = false;

	if (parseInt(postForm['control-visitors'].value) < parseInt(postForm['control-conversions'].value)) {
		foundErrors = true;
		postForm['control-conversions'].nextElementSibling.style.display = 'inline-block';
		// console.log('1');
	} else {
		postForm['control-conversions'].nextElementSibling.style.display = 'none';
		// console.log('2');
	}

	if (parseInt(postForm['variant-visitors'].value) < parseInt(postForm['variant-conversions'].value)) {
		foundErrors = true;
		postForm['variant-conversions'].nextElementSibling.style.display = 'inline-block';
		// console.log('3');
	} else {
		postForm['variant-conversions'].nextElementSibling.style.display = 'none';
		// console.log('4');
	}

	for (var i = 0; i < inputFields.length; i++) {
		if (inputFields[i].value === "" || isNaN(inputFields[i].value) || inputFields[i].value < 0) {
			foundErrors = true;
			inputFields[i].nextElementSibling.style.display = 'inline-block';
			// console.log('5');
		} else {
			inputFields[i].nextElementSibling.style.display = 'none';
			// console.log('6');
		}
	}

	if (!foundErrors) {
		writePostResult(calculatePostTestResults());
		// console.log('7');

		calculatorContainer.classList.add('results');
		// calculatorContainer.querySelector('.test-form h3').innerText = "Test Data";
		// console.log('8');
		postForm.querySelector('.button-container button').setAttribute('disabled', true);
		if (firstPostSubmit) {
			firstPostSubmit = false;

			postForm.querySelector('.button-container button').removeAttribute('disabled');
			postForm.querySelector('.button-container').classList.add('invisible');
			postForm.querySelector('.button-container button').innerText = "Apply Changes";
		} else {
			postForm.querySelector('.button-container button').innerText = "Changes Applied";

			setTimeout(function() {
				postForm.querySelector('.button-container button').removeAttribute('disabled');
				postForm.querySelector('.button-container').classList.add('invisible');
				postForm.querySelector('.button-container button').innerText = "Apply Changes";
			}, 3 * 1000);
		}
	} else {

		postForm.querySelector('.button-container').classList.remove('invisible');
	}

	calculatorContainer.classList.remove('loading');
}

function getRequiredVisitors(CR, MDE, variations) {
	var p = CR > 0.5 ? (1.0 - CR) : CR,
		delta = MDE * CR,
		t_alpha2 = 1.96,
		t_beta = 0.84,
		sd1 = Math.sqrt(2 * p * (1.0 - p)),
		sd2 = Math.sqrt(p * (1.0 - p) + (p + delta) * (1.0 - p - delta)),
		visitors = (t_alpha2 * sd1 + t_beta * sd2) * (t_alpha2 * sd1 + t_beta * sd2) / (delta * delta);

	return Math.round(visitors * variations);
}

function getDaysLeftToRun(currentSessions, requiredSessions, daysLive) {
	var sessionsPerDay = parseInt(currentSessions) / parseInt(daysLive),
		neededSessions = parseInt(requiredSessions) - parseInt(currentSessions);

	return Math.ceil(neededSessions / sessionsPerDay);
}

function calculatePostTestResults() {
	var controlVisitors = postForm['control-visitors'].value,
		controlConversions = postForm['control-conversions'].value,
		variantVisitors = postForm['variant-visitors'].value,
		variantConversions = postForm['variant-conversions'].value;

	var controlCR = controlConversions / controlVisitors,
		variantCR = variantConversions / variantVisitors,
		uplift = (variantCR / controlCR) - 1;

	var std = Math.sqrt(
			Math.pow(Math.sqrt(controlCR * (1 - controlCR) / controlVisitors), 2) +
			Math.pow(Math.sqrt(variantCR * (1 - variantCR) / variantVisitors), 2)
		),
		zScore = (controlCR - variantCR) / std,
		calcNormDist = window.jStat.normal.cdf(controlCR, variantCR, std),
		oneSided = zScore > 0 ? (1 - calcNormDist) : calcNormDist;
	var twoSided = 2 * oneSided;

	return {
		controlCR,
		variantCR,
		uplift,
		zScore,
		oneSided,
		twoSided,
		controlVisitors,
		controlConversions,
		controlCR,
		variantVisitors,
		variantConversions,
		variantCR,
		uplift
	};
}

function writePostResult(results) {
	var controlVisitors = document.querySelectorAll('[data-target="control-visitors"]'),
		controlConversions = document.querySelectorAll('[data-target="control-conversions"]'),
		controlCR = document.querySelectorAll('[data-target="control-cr"]'),
		variantVisitors = document.querySelectorAll('[data-target="variant-visitors"]'),
		variantConversions = document.querySelectorAll('[data-target="variant-conversions"]'),
		variantCR = document.querySelectorAll('[data-target="variant-cr"]'),
		uplift = document.querySelectorAll('[data-target="uplift"]'),
		significanceEl = document.querySelectorAll('[data-target="significance"]'),
		pValue = document.querySelector('[data-target="p-value"]'),
		zScore = document.querySelector('[data-target="z-score"]');

	for (var i = 0; i < controlVisitors.length; i++) {
		controlVisitors[i].innerText = results.controlVisitors;
	}

	for (var i = 0; i < controlConversions.length; i++) {
		controlConversions[i].innerText = results.controlConversions;
	}

	for (var i = 0; i < controlCR.length; i++) {
		controlCR[i].innerText = (results.controlCR * 100).toFixed(2) + "%";
	}

	for (var i = 0; i < variantVisitors.length; i++) {
		variantVisitors[i].innerText = results.variantVisitors;
	}

	for (var i = 0; i < variantConversions.length; i++) {
		variantConversions[i].innerText = results.variantConversions;
	}

	for (var i = 0; i < variantCR.length; i++) {
		variantCR[i].innerText = (results.variantCR * 100).toFixed(2) + "%";
	}

	for (var i = 0; i < uplift.length; i++) {
		var symbol = results.uplift > 0 ? '+' : '';
		uplift[i].innerText = symbol + (results.uplift * 100).toFixed(2) + "%";
	}

	for (var i = 0; i < significanceEl.length; i++) {
		if (postForm.sided.value === "one") {


			if (results.uplift > 0) {
				var significance = ((1 - results.oneSided) * 100).toFixed(2);
			} else {
				var significance = ((results.oneSided) * 100).toFixed(2);
			}
		} else {
			var significance = ((1 - results.twoSided) * 100).toFixed(2);
		}

		significanceEl[i].innerText = (significance == 100 ? ">99.9" : significance) + "%";
	}


	if (postForm.sided.value === "one") {
		pValue.innerText = results.oneSided.toFixed(6);
	} else {
		pValue.innerText = results.twoSided.toFixed(6);
	}

	zScore.innerText = results.zScore.toFixed(6);


	var resultsTables = document.querySelectorAll('.results-table'),
		outcome;
	if (results.uplift > 0) {
		outcome = "positive";
	} else {
		outcome = "negative";
	}

	var yesInfo = document.querySelector('[data-target="yes-info"]'),
		noInfo = document.querySelector('[data-target="no-info"]');
	if (results.uplift > 0 && significance > parseInt(postForm['significance-level'].value)) {
		yesInfo.innerHTML = "You’ve got a significant result! <strong>Your variant performs better than control.</strong>";
		noInfo.innerHTML = "If you haven’t reach your sample size, <strong>the observed uplift should not be analysed yet</strong>, even if it reached the desired confidence level.";
	} else if (results.uplift < 0 && significance > parseInt(postForm['significance-level'].value) && postForm.sided.value !== "one") {
		yesInfo.innerHTML = "You’ve got a significant result! <strong>Your variant performs worse than control.</strong>";
		noInfo.innerHTML = "If you haven’t reach your sample size, <strong>the observed uplift should not be analysed yet</strong>, even if it reached the desired confidence level.";
	} else {
		yesInfo.innerHTML = "The observed difference in conversion rate between control and variant <strong>isn’t big enough to declare a significant result.</strong>";
		noInfo.innerHTML = "The observed difference in conversion rate between control and variant <strong>is not yet big enough to declare a significant result.</strong>";
	}

	for (var i = 0; i < resultsTables.length; i++) {
		resultsTables[i].classList.remove("positive");
		resultsTables[i].classList.remove("negative");
		resultsTables[i].classList.remove("significant");

		resultsTables[i].classList.add(outcome);

		if (significance > parseInt(postForm['significance-level'].value) && (outcome === "positive" || (outcome === "negative" && postForm.sided.value !== "one"))) {
			resultsTables[i].classList.add("significant");
		}
	}

	var requiredSessions = getRequiredVisitors(results.controlCR, results.uplift, 2),
		daysLeftToRun = getDaysLeftToRun(parseInt(results.variantVisitors) + parseInt(results.controlVisitors), requiredSessions, postForm['days-length'].value);

	if (daysLeftToRun >= 0) {
		document.querySelector('.next-steps').classList.remove('hide-days-estimate');

		var daysLeft = document.querySelectorAll('.days-left');
		for (var i = 0; i < daysLeft.length; i++) {
			daysLeft[i].innerText = daysLeftToRun;
		}
	} else {
		document.querySelector('.next-steps').classList.add('hide-days-estimate');
	}

	savePostShareLink();
}
/* END: Post form handler */

/* START: Pre form handler */
var preForm = document.querySelector('form.pre-test-form__inner--form'),
	preInputFields = preForm.querySelectorAll('input[type="text"],input[type="number"]');

preForm.querySelector('.pre-test-form__inner--form .button-container button').addEventListener('click', function(e) {
	validatePreForm(e);
	// scrollToResults();
});

for (var i = 0; i < preInputFields.length; i++) {
	preInputFields[i].addEventListener('keyup', inputKeyUpHandler);
	preInputFields[i].addEventListener('blur', inputKeyUpHandler);
}

function validatePreForm(e) {
	if (typeof e !== "undefined") {
		e.preventDefault();
	}

	var calculatorContainer = document.querySelector('.calculator:not(.hidden)');

	calculatorContainer.classList.add('loading');

	var foundErrors = false;

	for (var i = 0; i < preInputFields.length; i++) {
		if (preInputFields[i].value === "" || isNaN(preInputFields[i].value) || preInputFields[i].value < 0) {
			foundErrors = true;
			preInputFields[i].nextElementSibling.style.display = 'inline-block';
		} else {
			preInputFields[i].nextElementSibling.style.display = 'none';
		}
	}

	if (parseInt(preForm['expected-traffic'].value) < parseInt(preForm['expected-conversions'].value)) {
		foundErrors = true;
		preForm['expected-conversions'].nextElementSibling.style.display = 'inline-block';
	} else if (preForm['expected-conversions'].value !== "") {
		preForm['expected-conversions'].nextElementSibling.style.display = 'none';
	}

	if (!foundErrors) {
		writePreResult(calculatePreTestResults());

		calculatorContainer.classList.add('results');
		// calculatorContainer.querySelector('.test-form h3').innerHTML = "Data from the page<br>you want to test";

		preForm.querySelector('.button-container button').setAttribute('disabled', true);
		preForm.querySelector('.button-container button').innerText = "Changes Applied";
		setTimeout(function() {
			preForm.querySelector('.button-container button').removeAttribute('disabled');
			preForm.querySelector('.button-container').classList.add('invisible');
			preForm.querySelector('.button-container button').innerText = "Apply Changes";
		}, 3 * 1000);
	} else {

		preForm.querySelector('.button-container').classList.remove('invisible');
	}

	calculatorContainer.classList.remove('loading');
}

function calculatePreTestResults() {
	var expectedVisitors = parseInt(preForm['expected-traffic'].value),
		expectedConversions = parseInt(preForm['expected-conversions'].value),
		numberOfVariants = parseInt(preForm['number-of-variants'].value) + 1,
		preSignificanceLevel = parseInt(preForm['pre-significance-level'].value) / 100,
		result = {};

	var crBaseline = expectedConversions / expectedVisitors;

	result = {
		weeks: {
			1: {
				uplift: upliftsToDetectAfterNDays(crBaseline, numberOfVariants, expectedVisitors / 30, 100, 1 * 7, preSignificanceLevel),
				requiredVisitors: Math.ceil(expectedVisitors / 30 * 7 * 1 / (numberOfVariants))
			},
			2: {
				uplift: upliftsToDetectAfterNDays(crBaseline, numberOfVariants, expectedVisitors / 30, 100, 2 * 7, preSignificanceLevel),
				requiredVisitors: Math.ceil(expectedVisitors / 30 * 7 * 2 / (numberOfVariants))
			},
			3: {
				uplift: upliftsToDetectAfterNDays(crBaseline, numberOfVariants, expectedVisitors / 30, 100, 3 * 7, preSignificanceLevel),
				requiredVisitors: Math.ceil(expectedVisitors / 30 * 7 * 3 / (numberOfVariants))
			},
			4: {
				uplift: upliftsToDetectAfterNDays(crBaseline, numberOfVariants, expectedVisitors / 30, 100, 4 * 7, preSignificanceLevel),
				requiredVisitors: Math.ceil(expectedVisitors / 30 * 7 * 4 / (numberOfVariants))
			},
			5: {
				uplift: upliftsToDetectAfterNDays(crBaseline, numberOfVariants, expectedVisitors / 30, 100, 5 * 7, preSignificanceLevel),
				requiredVisitors: Math.ceil(expectedVisitors / 30 * 7 * 5 / (numberOfVariants))
			},
			6: {
				uplift: upliftsToDetectAfterNDays(crBaseline, numberOfVariants, expectedVisitors / 30, 100, 6 * 7, preSignificanceLevel),
				requiredVisitors: Math.ceil(expectedVisitors / 30 * 7 * 6 / (numberOfVariants))
			}
		},
		crBaseline: crBaseline * 100
	};

	return result;
}

function writePreResult(results) {
	for (var i = 1; i <= 6; i++) {
		document.querySelector('[data-target="mde-' + i + '"]').innerText = (results.weeks[i].uplift * 100).toFixed(1) + '%';
		document.querySelector('[data-target="visitors-' + i + '"]').innerText = results.weeks[i].requiredVisitors;
	}

	document.querySelector('[data-target="expected-conversion-rate"]').innerText = results.crBaseline.toFixed(1) + '%';

	savePreShareLink();
}

function inputKeyUpHandler(e) {
	if (e.target.value === "") {
		e.target.nextElementSibling.style.display = 'inline-block';
	} else {
		e.target.nextElementSibling.style.display = 'none';
	}

	postForm.querySelector('.button-container').classList.remove('invisible');
	preForm.querySelector('.button-container').classList.remove('invisible');
}

function upliftsToDetectAfterNDays(conversionRate, variations, dailyUniqueVisitors, trafficAllocation, daysToRunTest, significance, tailed) {
	var power = 0.8,
		tailed = tailed || "two";

	var mdeValues = Array.from({
		length: 280
	}, (_, i) => {
		if (i < 200) {
			return ((i + 1) * 0.1) / 100
		} else {
			return (i - 179) / 100
		}
	})

	var mdeSampleSize = {}

	mdeValues.forEach(mdeValue => {
		mdeSampleSize[mdeValue] = {
			'one': calculateVariationSampleSize(mdeValue, conversionRate, significance, power, 'one') * variations,
			'two': calculateVariationSampleSize(mdeValue, conversionRate, significance, power, 'two') * variations
		}
	})


	var totalVisitors = Math.round(dailyUniqueVisitors * daysToRunTest * (trafficAllocation / 100.0)),
		closestDiff = Infinity,
		closestMDE = null;

	mdeValues.forEach(mdeValue => {
		var diff = mdeSampleSize[mdeValue][tailed] - totalVisitors
		diff = Math.sqrt(Math.pow(diff, 2))

		if (diff < closestDiff) {
			closestMDE = mdeValue
			closestDiff = diff
		}
	})

	if (!closestMDE) {
		return 0
	} else {
		return closestMDE
	}
}

function calculateVariationSampleSize(mde, conRate, significance, power, tail) {
	var moddedSignificance = tail === 'one' ? significance : significance / 2 + 0.5,
		a = normSigInverse(moddedSignificance) + normSigInverse(power),
		b = (conRate * (1 + mde)) - conRate,
		c = (
			conRate *
			(1 - conRate) +
			(conRate * (1 + mde)) *
			(1 - (conRate * (1 + mde)))
		)

	return Math.ceil(Math.pow(a / (b / Math.sqrt(c)), 2))
}

function normSigInverse(p) {
	var a1 = -39.6968302866538,
		a2 = 220.946098424521,
		a3 = -275.928510446969,
		a4 = 138.357751867269,
		a5 = -30.6647980661472,
		a6 = 2.50662827745924,
		b1 = -54.4760987982241,
		b2 = 161.585836858041,
		b3 = -155.698979859887,
		b4 = 66.8013118877197,
		b5 = -13.2806815528857,
		c1 = -7.78489400243029E-03,
		c2 = -0.322396458041136,
		c3 = -2.40075827716184,
		c4 = -2.54973253934373,
		c5 = 4.37466414146497,
		c6 = 2.93816398269878,
		d1 = 7.78469570904146E-03,
		d2 = 0.32246712907004,
		d3 = 2.445134137143,
		d4 = 3.75440866190742,
		p_low = 0.02425,
		p_high = 1 - p_low;

	var q, r, retVal;

	if ((p < 0) || (p > 1)) {
		// throw new Error("NormSInv: Argument out of range.");
		retVal = 0;
	} else if (p < p_low) {
		q = Math.sqrt(-2 * Math.log(p));
		retVal = (((((c1 * q + c2) * q + c3) * q + c4) * q + c5) * q + c6) / ((((d1 * q + d2) * q + d3) * q + d4) * q + 1);
	} else if (p <= p_high) {
		q = p - 0.5;
		r = q * q;
		retVal = (((((a1 * r + a2) * r + a3) * r + a4) * r + a5) * r + a6) * q / (((((b1 * r + b2) * r + b3) * r + b4) * r + b5) * r + 1);
	} else {
		q = Math.sqrt(-2 * Math.log(1 - p));
		retVal = -(((((c1 * q + c2) * q + c3) * q + c4) * q + c5) * q + c6) / ((((d1 * q + d2) * q + d3) * q + d4) * q + 1);
	}

	return retVal;
}



/* START: Questions Code */
var slider = document.querySelector('.slider'),
	backButtons = document.querySelectorAll('.back');

document.querySelector('.next-steps .answer-options a[data-answer="yes"]').addEventListener('click', function() {
	slider.classList.add('show-answer');
	slider.classList.add('show-answer-yes');
});

document.querySelector('.next-steps .answer-options a[data-answer="no"]').addEventListener('click', function() {
	slider.classList.add('show-answer');
	slider.classList.add('show-answer-no');
});

document.querySelector('.next-steps .answer-options a[data-answer="dont-know"]').addEventListener('click', function() {
	slider.classList.add('show-answer');
	slider.classList.add('show-answer-dont-know');
});

for (var i = 0; i < backButtons.length; i++) {
	backButtons[i].addEventListener('click', questionBack);
}

function questionBack(e) {
	slider.classList.remove('show-answer');
}

slider.addEventListener('transitionend', function() {
	if (!slider.classList.contains('show-answer')) {
		slider.classList.remove('show-answer-yes');
		slider.classList.remove('show-answer-no');
		slider.classList.remove('show-answer-dont-know');
	}
});

document.querySelector('.pre-test-link').addEventListener('click', function() {
	window.scrollTo({
		top: document.querySelector('.toggle .statisical-calculator__main-content--pre-test').offsetTop - 80,
		left: 0,
		behavior: 'smooth'
	});

	document.querySelector('.toggle .statisical-calculator__main-content--pre-test').click();
});
/* END: Questions Code */

/* START: Share Results Code */
var copyResultsContainers = document.querySelectorAll('.copy-result-container'),
	shareResultsShowButton = document.querySelectorAll('.share-results'),
	copyPostResultsField = document.querySelectorAll('.post-test .copy-result-input'),
	copyPreResultsField = document.querySelectorAll('.pre-test .copy-result-input'),
	copyPostResultsButton = document.querySelectorAll('.post-test .copy-result-container button'),
	copyPreResultsButton = document.querySelectorAll('.pre-test .copy-result-container button');

for (var i = 0; i < shareResultsShowButton.length; i++) {
	shareResultsShowButton[i].addEventListener('click', showCopyResultsField);
}

for (var i = 0; i < copyPostResultsButton.length; i++) {
	copyPostResultsButton[i].addEventListener('click', copyPostLink);
}

for (var i = 0; i < copyPreResultsButton.length; i++) {
	copyPreResultsButton[i].addEventListener('click', copyPreLink);
}

function showCopyResultsField(e) {
	for (var i = 0; i < copyResultsContainers.length; i++) {
		copyResultsContainers[i].classList.add('show-field');
	}
}

function savePostShareLink() {
	var postForm = document.querySelector('form.post-test-form__inner--form'),
		base = document.location.origin + document.location.pathname + "?";
	base += "control-visitors=" + postForm["control-visitors"].value;
	base += "&variant-visitors=" + postForm["variant-visitors"].value;
	base += "&control-conversions=" + postForm["control-conversions"].value;
	base += "&variant-conversions=" + postForm["variant-conversions"].value;
	base += "&days-length=" + postForm["days-length"].value;
	base += "&significance-level=" + postForm["significance-level"].value;
	base += "&sided=" + postForm["sided"].value;

	for (var i = 0; i < copyPostResultsField.length; i++) {
		copyPostResultsField[i].value = base;
	}
}

function savePreShareLink() {
	var preForm = document.querySelector('form.pre-test-form__inner--form'),
		base = document.location.origin + document.location.pathname + "?";
	base += "expected-traffic=" + preForm["expected-traffic"].value;
	base += "&expected-conversions=" + preForm["expected-conversions"].value;
	base += "&number-of-variants=" + preForm["number-of-variants"].value;
	base += "&pre-significance-level=" + preForm["pre-significance-level"].value;

	for (var i = 0; i < copyPreResultsField.length; i++) {
		copyPreResultsField[i].value = base;
	}
}

function copyPostLink(e) {
	if (navigator.clipboard) {
		navigator.clipboard.writeText(copyPostResultsField[0].value);
	} else {
		copyPostResultsField[0].select();
		document.execCommand("copy")
	}

	e.target.innerText = "Copied";
}

function copyPreLink(e) {
	if (navigator.clipboard) {
		navigator.clipboard.writeText(copyPreResultsField[0].value);
	} else {
		copyPreResultsField[0].select();
		document.execCommand("copy")
	}

	e.target.innerText = "Copied";
}

/* START: Sanitise number input */
var numberInputs = document.querySelectorAll('input[type="number"]');

for (var i = 0; i < numberInputs.length; i++) {
	numberInputs[i].addEventListener("keypress", sanitiseNumber);
}

function sanitiseNumber(evt) {
	if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57) {
		evt.preventDefault();
	}
}
/* END: Sanitise number input */

/* START: Lightboxes */
var lightbox = document.querySelector('.lightbox-outer'),
	lightboxButtons = lightbox.querySelectorAll('button');

var significanceInfos = document.querySelectorAll('.significance-info');
for (var i = 0; i < significanceInfos.length; i++) {
	significanceInfos[i].addEventListener('click', function() {
		showLightbox('significance');
	});
}

document.querySelector('.info.sample').addEventListener('click', function() {
	showLightbox('sample');
});
document.querySelector('.info.one-sided').addEventListener('click', function() {
	showLightbox('sided');
});
document.querySelector('.mde').addEventListener('click', function(e) {
	showLightbox('mde');
});
document.querySelector('.visitors').addEventListener('click', function() {
	showLightbox('visitors');
});

lightbox.addEventListener('click', hideLightbox);

for (var i = 0; i < lightboxButtons.length; i++) {
	lightboxButtons[i].addEventListener('click', hideLightbox);
}

function showLightbox(type) {
	document.body.classList.add('lightbox-open');
	lightbox.classList.add(type);
	lightbox.classList.add('show');
}

function hideLightbox(e) {
	if (!e.target.matches('.lightbox-inner') && !e.target.matches('.lightbox-inner h3') && !e.target.matches('.lightbox-inner p')) {
		document.body.classList.remove('lightbox-open');
		lightbox.classList.remove('show');
		lightbox.classList.remove('significance');
		lightbox.classList.remove('sample');
		lightbox.classList.remove('sided');
		lightbox.classList.remove('mde');
		lightbox.classList.remove('visitors');
	}
}

});
/* END: Lightboxes */